import { render, staticRenderFns } from "./PageEmbed.vue?vue&type=template&id=fd8c1716&scoped=true"
import script from "./PageEmbed.vue?vue&type=script&lang=js"
export * from "./PageEmbed.vue?vue&type=script&lang=js"
import style0 from "./PageEmbed.vue?vue&type=style&index=0&id=fd8c1716&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd8c1716",
  null
  
)

export default component.exports